import { FunctionComponent } from "react";

export const NissanFSLogo: FunctionComponent = () => {
  return (
    <img
      src="/images/brand/nissan-fs-logo.svg"
      className={"w-32 md:w-[161px] max-h-[40px] object-contain"}
      alt="Mobilize FS"
    />
  );
};
